import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem('cookie-consent', 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t-2 border-primary bg-background shadow-lg">
      <div className="container mx-auto flex items-center justify-between gap-8 px-8 py-3">
        <p className="text-sm text-muted-foreground">
          Ce site utilise des cookies pour améliorer votre expérience de navigation. En continuant, vous acceptez notre{' '}
          <Link to="/politique-de-confidentialite" className="text-primary underline hover:text-primary/80">
            politique de confidentialité
          </Link>
          .
        </p>
        <div className="flex shrink-0 gap-3">
          <Button variant="outline" className="h-9 px-6 text-sm rounded-md" onClick={refuse}>
            Refuser
          </Button>
          <Button className="h-9 px-6 text-sm rounded-md" onClick={accept}>
            Accepter
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
